import { getAppLocation } from '_common/utils/getAppLocation';
import { type OnboardingEnvironments } from 'App/redux/onboardingSlice';

/**
 * Returns if the onboarding is active and the user is in the onboarding environment
 */
export const isOnboardingActive = (
  state: RootState['onboarding'],
  environment: OnboardingEnvironments,
) => {
  const active = state.active[environment];
  const started = state.started[environment];
  const manualStartOnboarding = state.manualStartOnboarding;
  const firstAccessGatePassed = state.firstAccessModalAllowed === true;
  const appLocation = getAppLocation();

  let locationEnviroment: OnboardingEnvironments;

  const requiresManualStart = ['editor', 'dopdf', 'presentation'].includes(environment);
  const requiresFirstAccessGate = ['editor', 'dopdf', 'presentation'].includes(environment);
  /**
   * Parse location to OnboardingEnviroment
   */
  switch (appLocation) {
    case 'pdf': {
      locationEnviroment = 'dopdf';
      break;
    }
    case 'editor':
    case 'presentation':
    case 'explorer': {
      locationEnviroment = appLocation;
      break;
    }
    default: {
      return false; // not a valid onboarding environment
    }
  }

  return (
    locationEnviroment === environment &&
    (active || started) &&
    (!requiresManualStart || manualStartOnboarding) &&
    (!requiresFirstAccessGate || firstAccessGatePassed || manualStartOnboarding)
  );
};

export const isOnboardingExplorerActive = (state: RootState) => {
  return isOnboardingActive(state.onboarding, 'explorer');
};
export const isOnboardingEditorActive = (state: RootState) => {
  return isOnboardingActive(state.onboarding, 'editor');
};
export const isOnboardingPDFActive = (state: RootState) => {
  return isOnboardingActive(state.onboarding, 'dopdf');
};
export const isOnboardingPresentationActive = (state: RootState) => {
  return isOnboardingActive(state.onboarding, 'presentation');
};
